import * as React from "react";

const PlusIcon: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19.75 10C19.75 10.8292 19.0783 11.5005 18.25 11.5005H11.5V18.2505C11.5 19.0797 10.8283 19.75 10 19.75C9.17172 19.75 8.5 19.0797 8.5 18.2505V11.5005H1.75C0.921719 11.5005 0.25 10.8292 0.25 10C0.25 9.17078 0.921719 8.50047 1.75 8.50047H8.5V1.75047C8.5 0.92125 9.17172 0.25 10 0.25C10.8283 0.25 11.5 0.92125 11.5 1.75047V8.50047H18.25C19.0797 8.5 19.75 9.17031 19.75 10Z" fill="#9E9D9E"/>
        </svg>        

    );
};

export default React.memo(PlusIcon);
